import { useRef } from 'react'
import { useI18n } from '../../../provider/i18n'
import { MdLocationPin, MdEdit } from 'react-icons/md'
import { Blue300, Blue600 } from '../../../lib/colors'
import { BsCalendarHeartFill } from 'react-icons/bs'
import moment from 'moment'
import { UseFormReturn } from 'react-hook-form'
import { BasketForm } from '../NewBasket'
import {
  AddressSelectorModal,
  AddressSelectorModalType,
} from '../../../components/AddressSelectorModal'

type HomeCollectionFormProps = {
  form: UseFormReturn<BasketForm>
  address?: {
    address?: string | null
    postalCode?: string | null
    city?: string | null
  }
}

export const HomeCollectionForm = ({
  form,
  address,
}: HomeCollectionFormProps) => {
  const i18n = useI18n()
  const addressSelectorModalRef = useRef<AddressSelectorModalType>(null)
  const {
    register,
    watch,
    formState: { errors },
  } = form

  const collectionType = watch('collectionType') || 'home'

  return (
    <>
      <div className="p-4 flex gap-4 items-center border-b border-b-border border-opacity-20">
        <MdLocationPin size={24} color={Blue300} />
        <div className="flex-col flex md:flex-row md:justify-between w-full">
          <div className="flex flex-col justify-center text-left leading-tight text-sm text-blue-700">
            <p className="font-bold">
              {i18n.t('screens.basket.form.clientAddress.label')}
            </p>
          </div>
          <div className="flex justify-between gap-4">
            <p className="text-lg">
              <strong>{address?.address}</strong>{' '}
              <span className="text-blue-700">
                {address?.postalCode} {address?.city}
              </span>
            </p>
            <button>
              <MdEdit
                size={24}
                color={Blue600}
                onClick={() => addressSelectorModalRef.current?.show()}
              />
            </button>
          </div>
        </div>
      </div>
      <div className="p-4 flex gap-4 items-center border-b border-b-border border-opacity-20">
        <BsCalendarHeartFill size={24} color={Blue300} />
        <div className="flex-col flex md:items-center md:flex-row md:justify-between w-full">
          <div className="md:text-left leading-tight text-sm text-blue-700">
            <p className="font-bold">
              {i18n.t('screens.basket.form.date.label')}
            </p>
            <p>
              {i18n.t('screens.basket.form.date.possibleTimeDifference')}
            </p>
          </div>
          <div>
            <input
              className="text-lg font-bold focus:outline-none [&::-webkit-calendar-picker-indicator]:cursor-pointer"
              type="datetime-local"
              min={moment().format('YYYY-MM-DDTHH:mm')}
              {...register('collectionDate', {
                required:
                  collectionType === 'home'
                    ? i18n.t('screens.basket.form.date.rules.required')
                    : false,
                validate: (value) =>
                  collectionType === 'home' &&
                  value &&
                  new Date(value) > new Date()
                    ? undefined
                    : collectionType === 'home'
                      ? i18n.t('screens.basket.form.date.rules.minDate')
                      : undefined,
              })}
            />
            {errors.collectionDate && (
              <p className="hl-input-error">
                {errors.collectionDate.message as string}
              </p>
            )}
          </div>
        </div>
      </div>
      <AddressSelectorModal ref={addressSelectorModalRef} />
    </>
  )
}

